import {ACTION_TYPE, NavigationState} from './types'

export const setNavigation = (navigation: NavigationState) => ({
  type: ACTION_TYPE.SET_NAVIGATION,
  payload: navigation,
})
